import React from 'react';
import { FaSpotify, FaYoutube, FaInstagram, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const About = () => {
  return (
    <section id="about" className="section bg-dark">
      <div className="container about">
        <div className="about-copy reveal-up" data-reveal>
          <h2 className="section-title">About</h2>
          <p className="section-sub">
            David Jhay is an Afro gospel music artist blending vibrant Afrobeat rhythms with powerful,
            faith-filled messages. His uplifting sound inspires hope and positive living while connecting
            deeply with a new generation. Through his unique style, he is redefining the music space and
            showcasing Afro gospel music as both impactful and globally relevant.
          </p>
          <ul className="bullets">
            <li>Independent since day one</li>
            <li>Over 10M streams across platforms</li>
            <li>Live sets with modular synths</li>
          </ul>
        </div>
        <div className="about-art reveal-tilt" data-reveal>
          <div className="block block-pink" aria-hidden="true">
            <img src={process.env.PUBLIC_URL + '/assets/IMG_3020.JPG'} alt="" />
          </div>
          <div className="block block-cyan" aria-hidden="true">
            <img src={process.env.PUBLIC_URL + '/assets/IMG_3017.JPG'} alt="" />
          </div>
          <div className="block block-yellow" aria-hidden="true">
            <img src={process.env.PUBLIC_URL + '/assets/IMG_3041.JPG'} alt="" />
          </div>
        </div>
        <div className="platforms reveal-up" data-reveal>
          <a className="platform platform-youtube" href="https://tr.ee/G5Yw9RN0RH" target="_blank" rel="noreferrer">
            <FaYoutube className="plat-icon" aria-hidden="true" />
            <span className="plat-name">YouTube</span>
          </a>
          <a className="platform platform-tiktok" href="https://tr.ee/SsDmVa7X4V" target="_blank" rel="noreferrer">
            <FaTiktok className="plat-icon" aria-hidden="true" />
            <span className="plat-name">TikTok</span>
          </a>
          <a className="platform platform-spotify" href="https://tr.ee/tvwDfBXSIO" target="_blank" rel="noreferrer">
            <FaSpotify className="plat-icon" aria-hidden="true" />
            <span className="plat-name">Spotify</span>
          </a>
          <a className="platform platform-instagram" href="https://tr.ee/l0-fq6cWLN" target="_blank" rel="noreferrer">
            <FaInstagram className="plat-icon" aria-hidden="true" />
            <span className="plat-name">Instagram</span>
          </a>
          <a className="platform platform-x" href="https://tr.ee/sm-1jlWP6Y" target="_blank" rel="noreferrer">
            <FaXTwitter className="plat-icon" aria-hidden="true" />
            <span className="plat-name">X</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
